import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule }   from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { DlgTrabajandoComponent } from './components/dlg-trabajando/dlg-trabajando.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DlgErrorComponent } from './components/dlg-error/dlg-error.component';
import { PrincipalComponent } from './principal/principal.component';
import { AppLayoutComponent } from './app-layout/app-layout/app-layout.component';
import { MatMenuModule} from '@angular/material/menu';
import { MatToolbarModule} from '@angular/material/toolbar';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import {MatTabsModule} from '@angular/material/tabs'
import { NgxCsvParserModule } from 'ngx-csv-parser';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DlgAvisoComponent } from './components/dlg-aviso/dlg-aviso.component';
import { MatCardModule } from '@angular/material/card';
import { DlgPacientesModComponent } from './components/dlg-pacientes-mod/dlg-pacientes-mod.component';
import { TiposDocumentoComponent } from './tipos-documento/tipos-documento.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { DlgTiposDocumentoComponent } from './components/dlg-tipos-documento/dlg-tipos-documento.component';
import { TiposDomicilioComponent } from './tipos-domicilio/tipos-domicilio.component';
import { DlgTiposDomicilioComponent } from './components/dlg-tipos-domicilio/dlg-tipos-domicilio.component';
import { TiposMailsComponent } from './tipos-mails/tipos-mails.component';
import { DlgTiposMailsComponent } from './components/dlg-tipos-mails/dlg-tipos-mails.component';
import { TiposSexoComponent } from './tipos-sexo/tipos-sexo.component';
import { DlgTiposSexoComponent } from './components/dlg-tipos-sexo/dlg-tipos-sexo.component';
import { ObrasSocialesComponent } from './obras-sociales/obras-sociales.component';
import { DlgObrasSocialesComponent } from './components/dlg-obras-sociales/dlg-obras-sociales.component';
import { DlgBusquedasComponent } from './components/dlg-busquedas/dlg-busquedas.component';
import { ProvinciasComponent } from './provincias/provincias.component';
import { DlgProvinciaComponent } from './components/dlg-provincia/dlg-provincia.component';
import { DlgLocalidadComponent } from './components/dlg-localidad/dlg-localidad.component';
import { LocalidadComponent } from './localidad/localidad.component';
import { DlgDomiciliosComponent } from './components/dlg-domicilios/dlg-domicilios.component';
import { DlgMailsComponent } from './components/dlg-mails/dlg-mails.component';
import { DlgTelefonosComponent } from './components/dlg-telefonos/dlg-telefonos.component';
import { DlgTiposTelefonosComponent } from './components/dlg-tipos-telefonos/dlg-tipos-telefonos.component';
import { TiposTelefonosComponent } from './tipos-telefonos/tipos-telefonos.component';
import { DlgWhatsAppComponent } from './components/dlg-whats-app/dlg-whats-app.component';
import { DlgObrasSocialesPlanComponent } from './components/dlg-obras-sociales-plan/dlg-obras-sociales-plan.component';
import { DlgPrestacionesComponent } from './components/dlg-prestaciones/dlg-prestaciones.component';
import { PrestacionesComponent } from './prestaciones/prestaciones.component';
import { DlgObrasSocialesPrestacionComponent } from './components/dlg-obras-sociales-prestacion/dlg-obras-sociales-prestacion.component';
import { MatSelectModule } from '@angular/material/select';
import { DlgObraSocialPacienteComponent } from './components/dlg-obra-social-paciente/dlg-obra-social-paciente.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DlgRegistroCelEmisorComponent } from './components/dlg-registro-cel-emisor/dlg-registro-cel-emisor.component';
import { QRCodeModule } from 'angularx-qrcode';
import { CasillasMailComponent } from './casillas-mail/casillas-mail.component';
import { DlgCasillasMailComponent } from './components/dlg-casillas-mail/dlg-casillas-mail.component';
import { ConsorciosComponent } from './consorcios/consorcios.component';
import { DlgConsorciosComponent } from './components/dlg-consorcios/dlg-consorcios.component';
import { DlgEnviosComponent } from './components/dlg-envios/dlg-envios.component';
import { DlgEnvioNotificacionComponent } from './components/dlg-envio-notificacion/dlg-envio-notificacion.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DlgTrabajandoComponent,
    DlgErrorComponent,
    PrincipalComponent,
    AppLayoutComponent,
    DlgAvisoComponent,
    DlgPacientesModComponent,
    TiposDocumentoComponent,
    ConfiguracionComponent,
    DlgTiposDocumentoComponent,
    TiposDomicilioComponent,
    DlgTiposDomicilioComponent,
    TiposMailsComponent,
    DlgTiposMailsComponent,
    TiposSexoComponent,
    DlgTiposSexoComponent,
    ObrasSocialesComponent,
    DlgObrasSocialesComponent,
    DlgBusquedasComponent,
    ProvinciasComponent,
    DlgProvinciaComponent,
    DlgLocalidadComponent,
    LocalidadComponent,
    DlgDomiciliosComponent,
    DlgMailsComponent,
    DlgTelefonosComponent,
    DlgTiposTelefonosComponent,
    TiposTelefonosComponent,
    DlgWhatsAppComponent,
    DlgObrasSocialesPlanComponent,
    DlgPrestacionesComponent,
    PrestacionesComponent,
    DlgObrasSocialesPrestacionComponent,
    DlgObraSocialPacienteComponent,
    DlgRegistroCelEmisorComponent,
    CasillasMailComponent,
    DlgCasillasMailComponent,
    ConsorciosComponent,
    DlgConsorciosComponent,
    DlgEnviosComponent,
    DlgEnvioNotificacionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,
    MatInputModule,
    NgxMaskModule.forRoot(),
    MatTabsModule,
    NgxCsvParserModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatCardModule,
    MatSelectModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    QRCodeModule,
  ],
  entryComponents: [
    DlgTrabajandoComponent,
    DlgErrorComponent,
    DlgAvisoComponent,
    DlgPacientesModComponent,
  ],
  providers: [
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
